import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { SeoMetaOptions, SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'yc-web-app';
  private routerSub?: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private seoService: SeoService
  ) { }

  ngOnInit(): void {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const data = this.getMergedRouteData(this.route);
        const seoData = (data?.seo ?? {}) as SeoMetaOptions;
        const url = this.seoService.buildCanonicalUrl(this.router.url);
        const hasExplicitMeta = Boolean(seoData.title || seoData.description || seoData.image || seoData.type);
        if (hasExplicitMeta) {
          this.seoService.updateTags({ ...seoData, url });
        } else {
          this.seoService.syncFromDocument({ ...seoData, url });
        }
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  private getMergedRouteData(route: ActivatedRoute): Record<string, unknown> {
    let data: Record<string, unknown> = { ...route.snapshot.data };
    let child = route.firstChild;
    while (child) {
      data = { ...data, ...child.snapshot.data };
      child = child.firstChild;
    }
    return data;
  }
}
